// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".questionary-card[data-v-64c2dd14]{background-color:#fff;height:388px;width:318px;display:flex;flex-direction:column;justify-content:space-evenly;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
